import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Personvern from "@/pages/Personvern";
import Signer from "@/pages/Signer";
import Priser from "@/pages/Priser";
import ChiptuningPage from "@/pages/ChiptuningPage";
import BilnoklerPage from "@/pages/BilnoklerPage";
import { CookieBanner } from "@/components/site/CookieBanner";
import { LangProvider } from "@/lib/i18n";

function App() {
  return (
    <LangProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/personvern" element={<Personvern />} />
        <Route path="/priser" element={<Priser />} />
        <Route path="/chiptuning" element={<ChiptuningPage />} />
        <Route path="/bilnokler" element={<BilnoklerPage />} />
        <Route path="/signer/:token" element={<Signer />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster theme="dark" position="bottom-right" richColors />
      <CookieBanner />
    </BrowserRouter>
    </LangProvider>
  );
}

export default App;
